module.exports = __webpack_public_path__ + "static/media/icon-alert.08e7e25c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Nav/assets/icon-alert.svg
// module id = 1495
// module chunks = 193